import { api } from './api'
import type { OIDCClient, OIDCClientsResponse, CreateClientRequest, UpdateClientRequest } from '@/types/client'

export const clientsApi = {
  getClients: async (nextToken?: string): Promise<OIDCClientsResponse> => {
    console.log('🔍 Fetching OIDC clients', { nextToken })
    const params = nextToken ? { next_token: nextToken } : {}
    const response = await api.get<OIDCClientsResponse>('/oidc/clients', { params })
    console.log('✅ Fetched OIDC clients:', response.data)
    return response.data
  },

  getClient: async (clientId: string): Promise<OIDCClient> => {
    console.log('🔍 Fetching OIDC client:', clientId)
    const response = await api.get<OIDCClient>(`/oidc/clients/${clientId}`)
    console.log('✅ Fetched OIDC client:', response.data)
    return response.data
  },

  createClient: async (request: CreateClientRequest): Promise<OIDCClient> => {
    console.log('📝 Creating OIDC client:', request)
    const response = await api.post<OIDCClient>('/oidc/clients', request)
    console.log('✅ Created OIDC client:', response.data)
    return response.data
  },

  updateClient: async (request: UpdateClientRequest): Promise<OIDCClient> => {
    console.log('📝 Updating OIDC client:', request)
    const response = await api.put<OIDCClient>(`/oidc/clients/${request.client_id}`, request)
    console.log('✅ Updated OIDC client:', response.data)
    return response.data
  },

  deleteClient: async (clientId: string): Promise<void> => {
    console.log('🗑️ Deleting OIDC client:', clientId)
    await api.delete(`/oidc/clients/${clientId}`)
    console.log('✅ Deleted OIDC client')
  }
}